import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { EmmiterMessage, OutputMessage, ReceptorMessage } from 'src/app/models/common/output.model';
import { ProductSubType, ProductUI, ProductVariant, ProductWithVariantsUI, saledPrice } from 'src/app/shared-lib/domains/product';
import { AppService } from 'src/app/shared/app.service';
import { CartService } from "../../../shared/cart.service";
import { ProductCustomElementsComponent } from '../product-custom-elements/product-custom-elements.component';

export interface OnProductCardInfoActions extends ReceptorMessage {
  onVariantChange(event): void;

  onQtyChange(event): void;

  onAdd(product: ProductUI): void;
}

@Component({
  selector: 'app-product-part-info-interaction',
  templateUrl: './product-part-info-interaction.component.html',
  styleUrls: ['./product-part-info-interaction.component.scss'],
  standalone: false
})
export class ProductPartInfoInteractionComponent implements OnInit, EmmiterMessage {

  @Input() product: ProductWithVariantsUI;
  @Input() variantSelected$: Observable<ProductVariant>;
  @Input() isSummary: boolean;
  @Input() measurement: boolean;
  @Input() galleries;
  @Input() highestDiscount;

  @Output() action = new EventEmitter<OutputMessage>();

  @ViewChild(ProductCustomElementsComponent, { static: false }) productCustomElementsComponent: ProductCustomElementsComponent;

  constructor(private cartService: CartService, protected appS: AppService) {
  }

  ngOnInit(): void {
  }

  resetNotebookOptions() {
    var comp = this.productCustomElementsComponent;
    if (comp) {
      comp.initializeCustomOptions();
    }
  }

  emitAction(type: string, value?) {
    this.action.emit(new OutputMessage(type, value));
  }

  addQtyCustomProduct(event) {
    this.product.price = saledPrice(this.product);
    this.product.qty = event.qty;
    this.product.hasVariant = false;
    this.product.canAdd = true;
    this.product.isSoldOut = false;
  }

  maxQtyToAdd(product: ProductWithVariantsUI) {
    const productInCart = this.cartService.cart.items.find(it => it.product.id === product.id && it.product.variantId === product.variantId);
    return productInCart ? product.stock - productInCart.qty : product.stock;
  }

  protected readonly ProductSubType = ProductSubType;
}
